import "./ProjectPages.scss"

import ProjectHead from "../../assets/images/Project-10Latest/10latest-head.png"
import { HashLink } from "react-router-hash-link"

function ProjectPage10Latest() {

  // const handleQuickNav = (e) => {
  //   document.getElementById(e.target.dataset.anchor).scrollIntoView()
  // }

  return (
    <div className="csp">
      <div className="csp__container">

        <div className="csp__header">
          <div className="csp__header-bg">
            <img className="csp__header-bg-img" src={ProjectHead} alt="project preview" />
          </div>
          <h1 className="csp__project">Project: <span className="csp__name">10Latest</span></h1>
          <h2 className="csp__case-study">Case Study</h2>
        </div>

        <div className="csp__qnav">
          <ul className="csp__qnav-list">
            <li 
              className="csp__qnav-item" 
              // onClick={handleQuickNav}
              // data-anchor="project-breakdown"
            >
              <a href="#project-breakdown" className="csp__qnav-link">Project Breakdown</a>
            </li>
            <li className="csp__qnav-item" >
              <a href="#problems-and-solutions" className="csp__qnav-link">Problems and Solutions</a>
            </li>
            <li className="csp__qnav-item" >
              <a href="#things-learned" className="csp__qnav-link">Things I Have Learned</a>
            </li>
            <li className="csp__qnav-item" >
              <a href="#improvements" className="csp__qnav-link">Improvements</a>
            </li>
            <li className="csp__qnav-item" >
              <a href="#more-features" className="csp__qnav-link">More Features</a>
            </li>
          </ul>
        </div>

        <section className="csp__section">

          <div className="csp__anchor" id="project-breakdown"></div>

          <div className="csp__content">
            <h4 className="csp__title">Project Breakdown</h4>

            <div className="csp__section-sub">
              <h5 className="csp__title-sub">Why build this?</h5>
              <p className="csp__description">
                Among the many things that I like to do on my time off,
                I play League of Legends.
              </p>
              <p className="csp__description">
                League of Legends is a team-based strategy game where two teams of five powerful champions face off to destroy the other team's base.
                From over 140 champions to select from to make epic plays and take down towers as you battle your way to victory.
              </p>
              <p className="csp__description">
                Like many other games, there is a competitive mode.
                You play to improve your skills to climb and compete with better players.
                In doing so, it becomes relevant to be able to look at your past matches to improve on some weak points.
              </p>
              <p className="csp__description">
                This is why I have decided to create <a className="csp__links" target="_blank" rel="noreferrer" href="https://10latest.netlify.app">10Latest</a>,
                a web app to lookup 10 most recent matches for a given player on the NA (North American) server.
              </p>

              <h5 className="csp__title-sub">Inspirations</h5>
              <p className="csp__description">
                I am not the greatest when it comes to designing a web app,
                so I looked around for existing sites with similar services and pulled inspirations from it.
              </p>
              <p className="csp__description">
                As you will be able to see, this web app is inspired by <a className="csp__links" target="_blank" rel="noreferrer" href="https://u.gg/">U.GG</a>.
              </p>

              <h5 className="csp__title-sub">API used</h5>
              <p className="csp__description">
                <a className="csp__links" target="_blank" rel="noreferrer" href="https://developer.riotgames.com/">Riot Games API</a> was used to create this project.
                It comes packed with many endpoints that provides a huge amount of data that can be used in so many ways.
              </p>

              <h5 className="csp__title-sub">Time</h5>
              <p className="csp__description">
                This project took about 2 weeks of total work time from <span className="code-snippet">npx create-react-app</span> to deployment on Netlify.
              </p>
            </div>
          </div>
        </section>

        <section className="csp__section">

          <div className="csp__anchor" id="problems-and-solutions"></div>

          <div className="csp__content">
            <h4 className="csp__title">Problems and Solutions</h4>
            <div className="csp__section-sub">
              <h5 className="csp__title-sub">API calls</h5>

              <div className="csp__section-sub-sub">
                <div className="csp__left-bar"></div>
                <div className="csp__right">
                  <h6 className="csp__title-sub-sub">API key expiration</h6>
                  <p className="csp__description">
                    The development API key can be obtained by anyone with a Riot Games account, but it expires every 24 hours.

                    I knew that would be an issue once the project is deployed,
                    luckly Riot Games provides product registration service options to obtain a more permanent API key.

                    In my case, I registered for a personal API key for a small scale project.
                    I got the approval and obtained my API key after a few business days.
                  </p>
                  <h6 className="csp__title-sub-sub">Syncing multiple API fetches</h6>
                  <p className="csp__description">
                    The app displays 10 recent matches to the user, and in MatchCards rendering sequence,
                    all of the fetch promises needed to be resolved before hand.

                    Since some data would arrive later than others,
                    some MatchCards would be empty when data was mapped to render components.

                    I remembered reading about how <span className="code-snippet">Promise.all()</span> would be perfect for something like this.
                    Pushing all the promises into an array and passing it through <span className="code-snippet">Promise.all()</span> to make sure the data is available when ALL of the promises have been resolved.
                  </p>
                </div>
              </div>
            
              <h5 className="csp__title-sub">Deployment</h5>
              <p className="csp__description">
                Once the app was deployed onto Netlify, the home page is showing like it is suppose.
                Everytime the user searches for a summoner name, they are directed to the path
                <span className="code-snippet">/summoner/&lt;summoner-name&gt;</span> and "Page Not Found" from Netlify would be shown.
              </p>
              <p className="csp__description">
                Since my project is built in React, React Browser Router handles all the routes to be directed to
                <span className="code-snippet">[index.html]</span>.
                Netlify on the other hand, when it sees users trying to route to
                <span className="code-snippet">/summoner/&lt;summoner-name&gt;</span>,
                it is looking for a file named
                <span className="code-snippet">[/summoner/&lt;summoner-name&gt;.html]</span> which does not exist.
              </p>
              <p className="csp__description">
                Within my project, I had to creat a file called
                <span className="code-snippet">[_redirects]</span> with no extensions under the
                <span className="code-snippet">[public]</span> folder with only
                <span className="code-snippet">&#47;*    /index.html    200</span> typed inside.
              </p>
              <p className="csp__description">
                This way, when a user is trying to direct to <span className="code-snippet">/summoner/&lt;summoner-name&gt;</span>,
                Netlify will properly route towards <span className="code-snippet">10latest.netlify.app/summoner/&lt;summoner-name&gt;</span>
              </p>
            </div>
          </div>
        </section>

        <section className="csp__section">

          <div className="csp__anchor" id="things-learned"></div>

          <div className="csp__content">
            <h4 className="csp__title">Things I have learned</h4>
            <p className="csp__description">
              I have learned many things through this project, I will be pointing out the most important ones.
            </p>

            <div className="csp__section-sub">
              <h5 className="csp__title-sub">Skills</h5>
              <p className="csp__description">
                Through analysing existing web apps I have learned various ways to make styling easier for me.
                Sometimes putting a component into a div to poisition it just right saves so much trouble.
              </p>
              <p className="csp__description">
                A div per component keeps the headaches away!
              </p>

              <h5 className="csp__title-sub">Be patient and read</h5>
              <p className="csp__description">
                Reading documentation and understanding what the different endpoints for a given API provides saves a lot of time.
              </p>
              <p className="csp__description">
                I was so excited to work on this project that I dove right in with the first endpoint that looked promising,
                ended up needing to rewrite 25% of my code at that time to adapt to the data from another endpoint that was more relevent.
              </p>

              <p>TL;DR: Slow down and look at the bigger picture to see a clearer picture before I start</p>

              <h5 className="csp__title-sub">Organization</h5>
              <p className="csp__description">
                Being organized with different branches on the project really helped to stay focused on one feature,
                building it as much as possible beofre moving onto the next.
              </p>
              <p className="csp__description">
                This method felt less overwhelming,
                breaking components down to even smaller components.
              </p>
            </div>
          </div>
        </section>

        <section className="csp__section">

          <div className="csp__anchor" id="improvements"></div>

          <div className="csp__content">
            <h4 className="csp__title">Improvements</h4>
            <div className="csp__section-sub">
              <h5 className="csp__title-sub">Lookup per server</h5>
              <p className="csp__description">
                Users may look up any summoner on the NA (North American) server right now,
                the ability to access the other servers will be implemented in the future.
              </p>
              <h5 className="csp__title-sub">Item information</h5>
              <p className="csp__description">
                Item information for users to read and quickly analyse if it had an impact on the result of the match will help for better future decision making.
              </p>
              <h5 className="csp__title-sub">API Key</h5>
              <p className="csp__description">
                Currently, the API fetch requests are done all from the front end.
                It also means that my API key is not completely hidden from users.
              </p>
              <p className="csp__description">
                Setting up a back-end as an intermidiate to fetch the data would be a safer way to store the API key.
                The server can also double as a filter to only send necessary data to display to the users.
              </p>

              <div className="csp__section-sub-sub">
                <div className="csp__left-bar"></div>
                <div className="csp__right">
                  <div className="csp__updated">Added on 2023-02-08</div>
                  <h6 className="csp__title-sub-sub">Current Solution</h6>
                  <p className="csp__description">
                    I have found a solution that suits my needs for the moment after a little bit of Googling.
                  </p>
                  <p className="csp__description">
                    I follow guidelines within this article writen by freeCodeCamp: <a className="csp__links" target="_blank" rel="noreferrer" href="https://www.freecodecamp.org/news/how-to-access-secret-api-keys-using-netlify-functions-in-a-react-app/">How To Securely Access Seceret API key using Netlify Funcitons in a React App</a> and clarification from Netlify Docs <a className="csp__links" target="_blank" rel="noreferrer" href="https://www.netlify.com/products/functions/">Netlify Functions</a>.
                  </p>
                  <p className="csp__description">
                    Spliting all my fetches from the utilities.js file to each fetch its own file in Netlify functions. All contained in the netlify folder in the root of the project.
                  </p>
                  <p className="csp__description">
                    This way, I can execute server-side code without having to deploy a server of my own!
                  </p>
                  <p className="csp__description">
                    Thank you Netlify!!
                  </p>
                  {/* <div className="csp__updated">
                    <p>Updated: 2023-02-08</p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="csp__section">

          <div className="csp__anchor" id="more-features"></div>

          <div className="csp__content">
            
            <h4 className="csp__title">More Features</h4>

            <div className="csp__section-sub">
              <h5 className="csp__title-sub">Mobile Friendly</h5>
              <p className="csp__description">
                The main goal was to be able to fetch data from a game to be displayed to the users and 10Latest is built mainly for desktop use,
                maybe even tablet use for the moment. Implementing a mobile view will give users the ability to show off their League of Legends skills on the go!
              </p>
            </div>
          </div>
        </section>

        <div className="csp__navigate-bottom">
          <HashLink smooth to="/#projects">
            <div className="csp__home">Back to Projects</div>
          </HashLink>
        </div>
      </div>
    </div>
  )
}

export default ProjectPage10Latest